import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Smartphone, Check, Share, Plus } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const MobileApp = () => {

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/30">
      <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-12 max-w-6xl">
        <Link to="/dashboard">
          <Button variant="ghost" className="mb-6 sm:mb-8">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Dashboard
          </Button>
        </Link>
        
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
          <div className="inline-flex p-6 rounded-full bg-primary/10 text-primary mb-6">
            <Smartphone className="w-16 h-16" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-4 animate-fade-in">
            Use LaunchToRevenue On Your Phone
          </h1>
          <div className="inline-block px-6 py-3 bg-gradient-to-r from-primary/20 to-accent/20 rounded-full mb-6 animate-fade-in">
            <p className="text-2xl md:text-3xl font-semibold text-primary">
              Available Now!
            </p>
          </div>
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mb-8 animate-fade-in">
            Add LaunchToRevenue to your home screen for a native app-like experience on your phone or tablet.
          </p>

          <div className="grid md:grid-cols-2 gap-6 max-w-4xl w-full mb-8">
            <Card>
              <CardContent className="pt-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 rounded-full bg-primary/10">
                    <Share className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="text-xl font-semibold">iOS (iPhone/iPad)</h3>
                </div>
                <ol className="text-left space-y-2 text-sm text-muted-foreground">
                  <li className="flex items-start gap-2">
                    <span className="font-semibold text-primary">1.</span>
                    <span>Open this site in Safari</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="font-semibold text-primary">2.</span>
                    <span>Tap the Share button (square with arrow)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="font-semibold text-primary">3.</span>
                    <span>Scroll down and tap "Add to Home Screen"</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="font-semibold text-primary">4.</span>
                    <span>Tap "Add" to confirm</span>
                  </li>
                </ol>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="pt-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 rounded-full bg-primary/10">
                    <Plus className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="text-xl font-semibold">Android</h3>
                </div>
                <ol className="text-left space-y-2 text-sm text-muted-foreground">
                  <li className="flex items-start gap-2">
                    <span className="font-semibold text-primary">1.</span>
                    <span>Open this site in Chrome</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="font-semibold text-primary">2.</span>
                    <span>Tap the menu (three dots) in the top right</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="font-semibold text-primary">3.</span>
                    <span>Tap "Add to Home screen" or "Install app"</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="font-semibold text-primary">4.</span>
                    <span>Tap "Add" or "Install" to confirm</span>
                  </li>
                </ol>
              </CardContent>
            </Card>
          </div>

          <div className="flex flex-wrap gap-4 justify-center">
            <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-muted/50">
              <Check className="w-5 h-5 text-green-500" />
              <span className="text-sm">Works on any device</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-muted/50">
              <Check className="w-5 h-5 text-green-500" />
              <span className="text-sm">Full app experience</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-muted/50">
              <Check className="w-5 h-5 text-green-500" />
              <span className="text-sm">No app store needed</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileApp;